<template>
	<div class="detail">
		<PageHeaderLayout :isBack="true">
			<div class="main">
				<div class="text-content">{{ detail.deliver_content }}</div>
				<div class="img-content">
					<div class="item-img" v-for="url in detail.deliver_images" :key="url">
						<el-image style="width: 100px; height: 100px" :src="url" :preview-src-list="detail.img"></el-image>
					</div>
				</div>
				<div style="margin-top: 20px" v-if="detail.deliver_status==1">
					<span class="dialog-footer">
						<el-button @click="jujue" type="danger">不通过</el-button>
						<el-button @click="tonguo" class="tonguo" type="primary">通过</el-button>
					</span>
				</div>
			</div>

			<el-dialog title="提示" :visible.sync="examinedialogVisible" width="50%" @close="userClose">
				<div style="margin-top: 30px">
					<el-input type="textarea" placeholder="请输入拒绝原因" v-model="detail.deliver_message" maxlength="100" show-word-limit :rows="5"></el-input>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="examinedialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="examine">确 定</el-button>
				</span>
			</el-dialog>
		</PageHeaderLayout>
	</div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue';
import PageHeaderLayout from '@/layouts/PageHeaderLayout';
export default {
	components: {
		DatePicker,
		PageHeaderLayout
	},
	data() {
		return {
			query: {},
			detail: {
				deliver_content:'',
				deliver_images:[],
				deliver_status: '', //交付状态2交付通过3交付未通过,
				deliver_message: '' //未通过原因
			},
			examinedialogVisible: false
		};
	},
	created() {
		this.query=this.$route.query
		this.getInfo();
	},

	methods: {
	async	getInfo() {
			let data=await this.$api.getDaily_taskDeliver_view({id:this.query.id})
			console.log(data)
			this.detail=data
		},
		async examine() {
			let params = {
				id:this.query.id,
				deliver_status:this.detail.deliver_status,
				deliver_message:this.detail.deliver_message,
			};
		await this.$api.getDaily_taskDeliver_audit(params);
			this.examinedialogVisible = false;
			this.$message.success('审核成功');
			this.getInfo()
		},
		jujue() {
			this.examinedialogVisible = true;
			this.detail.deliver_status = 3;
		},
		tonguo() {
			this.detail.deliver_status = 2;
			this.examine()
		}
	}
};
</script>

<style scoped lang="scss">
.detail {
	background-color: #fff;
	border-radius: 24px;
	padding: 24px;
	height: 100%;
	.text-content {
		width: 500px;
		min-height: 120px;
		background-color: #f2f3f7;
		border-radius: 24px;
		padding: 24px;
	}
	.img-content {
		margin-top: 24px;
		.item-img {
			margin-bottom: 24px;
		}
		.img-icon {
			width: 500px;
			height: auto;
		}
	}
	.tonguo {
		margin-left: 50px;
	}
}
</style>
